import type { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { ControlledDateRangePickerProps } from '@packages/components/controls/controlled-date-range-picker/controlled-date-range-picker';
import { ControlledDateRangePicker } from '@packages/components/controls/controlled-date-range-picker/controlled-date-range-picker';
import { Stack, Typography } from '@packages/fenrir/components';

import { transform } from './transform';

export const RuleDuration = <T extends FieldValues>({
  control,
  name,
  ...rest
}: ControlledDateRangePickerProps<T>) => {
  const { t } = useTranslation('components', {
    keyPrefix: 'alertConfigurationRules.ruleDuration',
  });

  return (
    <Stack spacing={2}>
      <Typography variant="h3">{t('title')}</Typography>

      <Typography>{t('description')}</Typography>

      <ControlledDateRangePicker
        {...rest}
        transform={transform}
        control={control}
        name={name}
        wrapperProps={{ maxWidth: 505 }}
      />
    </Stack>
  );
};
